// Auto-generated from beautyProfilerAllures.csv
// Do not edit manually

import { CSVRow } from '../lib/csvLoader';

export const beautyProfilerAlluresData: CSVRow[] = [
  {
    "id": "1",
    "label": "EMPOWERED",
    "description": "When confidence whispers, desire listens. Charisma flows through every gesture, commanding attention with natural strength. Your beauty ritual becomes a sensual statement of presence — sculpted in bold textures and exquisite details. Lips lacquered like lacquered heels. Fragrance as an invisible signature, an irresistible power."
  },
  {
    "id": "2",
    "label": "ELEGANT",
    "description": "Where timeless meets modern, style becomes instinctive. Your beauty ritual is a reflection of your elevated aesthetic : think sculpted textures, soft definition, and fragrances that capture the essence of pure elegance."
  },
  {
    "id": "3",
    "label": "UNEXPECTED",
    "description": "Effortless yet unforgettable, your allure defies convention with a sharp eye for what’s next. Your beauty ritual is layered and instinctive— where bold textures meet unexpected notes. A scent of daring contrasts, unexpected pairings. Always original. Never ordinary."
  },
  {
    "id": "4",
    "label": "RADIANT",
    "description": "You don’t chase attention—you glow with it. Effortless and luminous, your beauty feels like second skin. It unfolds in soft tones and quiet confidence, expressed with instinctive grace. Your ritual is instinctive—whisper-light textures, airy hues, and a fragrance that captures the brightness of a new beginning."
  }
];
